
export class PopConteudoUpdate {
  public id: number;
  public html: string;

  constructor(id: number, html: string ) {
    this.id = id;
    this.html = html;
  }
}